import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Heartbeat, GoogleLogo } from "@phosphor-icons/react";

const BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/86e4117b-2120-43f9-8b87-c26dfecc676b/images/7d573b189f252f9b79bb7c963366ee3431627baf4d1ac2480c2d715193f984a9.png";

export default function Login() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-gray-400">Loading…</div>;
  }
  if (user) return <Navigate to="/dashboard" replace />;

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const onSignIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12 relative bg-gray-50"
      style={{
        backgroundImage: `url(${BG_URL})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-white/60 backdrop-blur-[2px]" />
      <div className="relative w-full max-w-md">
        <div className="bg-white border border-gray-200 rounded-xl shadow-xl p-8 animate-fade-up">
          <div className="flex flex-col items-center text-center mb-8">
            <div className="w-12 h-12 rounded-xl bg-gray-900 flex items-center justify-center mb-4">
              <Heartbeat size={24} weight="fill" className="text-red-500 animate-brand-pulse" />
            </div>
            <h1 className="font-display text-2xl font-semibold tracking-tight text-gray-900">
              Pulse · AssureAI
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Sign in with your invited Google account.
            </p>
          </div>

          <button
            onClick={onSignIn}
            className="w-full inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-50 text-gray-800 text-sm font-medium px-4 py-2.5 transition-colors shadow-sm"
            data-testid="google-signin-btn"
          >
            <GoogleLogo size={18} weight="bold" className="text-gray-700" />
            Sign in with Google
          </button>

          <div className="mt-6 pt-5 border-t border-gray-100 text-[11px] text-gray-500 leading-relaxed">
            Only invited Gmail addresses can access this console. Need access?
            Ping <span className="font-mono">d.nitin200411@gmail.com</span>.
          </div>
        </div>
        <div className="mt-6 text-center text-[11px] text-gray-500 tracking-wider uppercase">
          Internal use · Transform Automations India Pvt. Ltd.
        </div>
      </div>
    </div>
  );
}
